import gql from 'graphql-tag'

const meQuery = gql`
  query getMe {
    me {
      _id
      email
      name
    }
  }
`
const preferencesQuery = gql`
  query getLoyaltyPreferences($websiteId: ID) {
    preferences: userPreferences(websiteId: $websiteId) {
      _id
      loyaltyProgram
    }
  }
`
export {meQuery, preferencesQuery}
